import React from 'react';

import { ArrowBackIcon } from 'icons';
import { IconButton, styled } from 'netline-ui';

import styles, { mobileHeaderClasses } from './MobileHeader.styles';

const MobileHeaderRoot = styled('header', { name: mobileHeaderClasses.$name })(styles);

const MobileHeader = ({ title, onClose }: { title: string; onClose: () => void }) => (
  <MobileHeaderRoot className={mobileHeaderClasses.root}>
    <IconButton onClick={onClose} data-testid="MobilePreferences-closeIcon">
      <ArrowBackIcon className={mobileHeaderClasses.closeIcon} />
    </IconButton>
    <span className={mobileHeaderClasses.title} data-testid="MobilePreferences-title">
      {title}
    </span>
  </MobileHeaderRoot>
);

export default MobileHeader;
